/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import customModal from "../customModal/customModal.vue";

export default {
  name: "VersionEffectiveDateModal",
  components: {
    customModal,
  },
  emits: ["close", "save"],
  props: {
    labCode: {
      type: String,
      required: true,
    },
    testCode: {
      type: String,
      required: true,
    },
    oldVersionNo: {
      type: String,
      default: "",
    },
    currentVersion: {
     type: String,
      default: "",
    },
    studyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      version: "",
      effectiveDate: "",
      copyVersion:"",
      isActive: false,
      baseurl: process.env.VUE_APP_Service_URL,
      errors: [],
      token: "",
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
  },
  methods: {
    validate() {
      this.errors = [];

      if (!this.version || this.version.trim() === "") {
        this.errors.push(this.$t("navigations.version") + " " + this.$t("navigations.is required"));
      }

      if (!this.effectiveDate) {
        this.errors.push(this.$t("navigations.effective date") + " " + this.$t("navigations.is required"));
      } else if (!moment(this.effectiveDate, "YYYY-MM-DD", true).isValid()) {
        this.errors.push(this.$t("navigations.invalid effective date"));
      }

      return this.errors.length === 0;
    },

   async saveVersionDetails() {
  if (!this.validate()) {
    alert(this.errors.join("\n"));
    return;
  }

  const now = new Date().toISOString();
  const userId = store.getters.getUserId || "system";
  const userEmail = store.getters.getUserEmail || "system@domain.com";
  this.version = this.version.trim();

  const payload = {
    labCode: this.labCode,
    testCode: this.testCode,
    oldVersionNo: this.oldVersionNo,
    newVersionNo: this.version,
    currentVersion: this.version,
    effectiveDate: new Date(this.effectiveDate).toISOString(),
    isActive: this.isActive,
    studyId: this.studyId,
  };

  try {
    await axios.post(
      `${this.baseurl}/management/labreferencerange/newversion`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        },
      }
    );
    alert(this.$t("navigations.version saved successfully"));
    localStorage.setItem("newlyCreatedVersion", this.version);

    this.$emit("save", payload);
    this.$emit("close");
    this.$emit("showSetVersion", true);
  } catch (err) {
    let errorMessage = this.$t("navigations.version save failed");
    let showAlert = false;

    if (err.response?.data?.messages?.length) {
      let fullMsg = err.response.data.messages[0];
      let shortMsg = fullMsg.includes(":") ? fullMsg.split(":")[1].trim() : fullMsg;
      shortMsg = shortMsg.split("\n")[0].trim();

      if (/Version already exists/i.test(fullMsg)) {
        errorMessage = "Version already exists.";
        showAlert = true;
      } else if (/No matching records found for versioning/i.test(fullMsg)) {
        errorMessage = "No matching records found for versioning.";
        localStorage.setItem("newlyCreatedVersion", this.version);
        this.$emit("showSetVersion", true);
      } else {
        console.error("Server Error:", shortMsg);
      }
    } else if (err.response?.data?.detail) {
      errorMessage = err.response.data.detail;
      console.error("Error detail:", err.response.data.detail);
    } else {
      console.error("Unhandled Error:", err);
    }

    if (showAlert) {
      alert(errorMessage);
    }
  }
},

  },
};
